var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFastDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_463_573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8954 0C16.5675 0 9.79224 6.75671 9.79224 15.0619C9.79224 23.3671 16.5675 30.1238 24.8954 30.1238C33.2234 30.1238 39.9986 23.3671 39.9986 15.0619C39.9985 6.75671 33.2233 0 24.8954 0ZM24.8954 27.7783C17.8608 27.7783 12.1377 22.0738 12.1377 15.0619C12.1377 8.05001 17.8608 2.34548 24.8954 2.34548C31.9301 2.34548 37.6531 8.05008 37.6531 15.0619C37.6531 22.0737 31.93 27.7783 24.8954 27.7783Z",
    fill: "#58A771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0684 7.47174H23.7229V16.2346H32.5049V13.8891H26.0684V7.47174Z",
    fill: "#58A771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12476 28.3416L7.39679 22.0872L9.0527 23.7478L2.78067 30.0022L1.12476 28.3416Z",
    fill: "#58A771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20.5931L5.77397 14.8354L7.42988 16.496L1.65591 22.2537L0 20.5931Z",
    fill: "#58A771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7925 38.3346L23.5665 32.5769L25.2224 34.2375L19.4484 39.9952L17.7925 38.3346Z",
    fill: "#58A771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.80347 35.5383L10.1334 28.2291L11.7893 29.8897L4.45938 37.1989L2.80347 35.5383Z",
    fill: "#58A771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.021 37.2125L16.293 30.9581L17.9489 32.6187L11.6769 38.8731L10.021 37.2125Z",
    fill: "#58A771"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_463_573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastDelivery);
export default __webpack_public_path__ + "static/media/fast-delivery.6c8f72e55edc6ccb5ad6548cf367be8b.svg";
export { ForwardRef as ReactComponent };